import React, { useState } from 'react';
import api from '../Api/Axios';
import Cookies from 'js-cookie';
import { useAuth } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../Assets/Styles/LoginPage.css';

function LoginPage() {
    const { setToken } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setErrorMsg('');

        try {
            const res = await api.post('/auth/login', {
                email: email.trim(),
                password
            });

            Cookies.set('token', res.data.token, { secure: true, sameSite: 'Strict' });

            setToken(res.data.token);

            navigate('/clients');

        } catch (err) {
            console.error(err);
            setErrorMsg(err.response?.data?.error || 'Login failed');
        }
    };

    return (
        <div className="login-container">
            <h2>🔐 Login</h2>
            <form onSubmit={handleLogin}>
                <label>Email</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <label>Password</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />

                {errorMsg && <p className="error">{errorMsg}</p>}

                <button type="submit">Login</button>
            </form>
        </div>
    );
}

export default LoginPage;
